module.exports = __webpack_public_path__ + "img/zh_table2.03955330.png";